export const tokenize = (text) => {
    return text
        .replace(/[^\p{Letter}\p{Mark}]+/gu, ' ')
        .trim()
        .split(' ');
};
